<template>
<el-dialog class='edit-member-dialog' title='编辑成员信息' size='small' :visible.sync="dialogVisible">
  <el-form label-position='top'>
    <el-form-item label="姓名">
      <el-col :span="17">
        <el-input placeholder="成员姓名" disabled v-model="name">
        </el-input>
      </el-col>

      <el-col :span="6" :offset="1">
        <el-select v-model="role" :disabled="role === 'owner'">
          <el-option v-for="item in roles" :key="item" :label="$t(`organization.roles.${item}`)" :value="item" :disabled="item === 'owner'">
          </el-option>
        </el-select>
      </el-col>
    </el-form-item>

    <el-form-item label="邮箱地址">
      <el-input placeholder="邮箱地址" disabled v-model="email">
      </el-input>
    </el-form-item>

    <el-form-item label="所属部门">
      <el-input v-model="department"></el-input>
    </el-form-item>
  </el-form>

  <div slot="footer" class="dialog-footer">
    <el-button type='text' @click="close">{{$t('common.buttons.cancel')}}</el-button>
    <el-button type='primary' @click="save">{{$t('common.buttons.ok')}}</el-button>
  </div>
</el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      name: null,
      email: null,
      department: null,
      role: null,
      orgId: null,
      memId: null,
      success: null,
      roles: ['owner', 'admin', 'member']
    }
  },
  methods: {
    open(params) {
      // only need name and id
      if (params.member && params.member.user) {
        this.name = params.member.user.nickname
        this.email = params.member.user.email
        this.department = params.member.department
        this.role = params.member.role
      }
      this.orgId = params.orgId
      this.memId = params.memId
      this.success = params.success
      this.dialogVisible = true
    },
    close() {
      this.dialogVisible = false
      this.name = null
      this.email = null
      this.department = null
      this.role = null
      this.orgId = null
      this.memId = null
      this.success = null
    },
    save() {
      let vm = this
      vm.$store.dispatch('organization/editMember', {
        orgId: vm.orgId,
        memId: vm.memId,
        department: vm.department,
        role: vm.role
      }).then(_ => {
        vm.$message('保存成功')
        if (typeof vm.success === 'function') {
          vm.success()
        }
        vm.close()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// edit_member.dialog.vue?0c0c51ac